import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=1c143a87&scoped=true"
import script from "./FaqList.vue?vue&type=script&lang=js"
export * from "./FaqList.vue?vue&type=script&lang=js"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=1c143a87&prod&scoped=true&lang=scss"
import style1 from "./FaqList.vue?vue&type=style&index=1&id=1c143a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c143a87",
  null
  
)

export default component.exports